import { View } from 'react-native';
import { styles } from './DiscountScaleProgressMini.styles';
import Animated from 'react-native-reanimated';
import { DiscountScaleProgressProps } from '../DiscountScaleProgress.types';
import { useDiscountScaleProgress } from '../useDiscountScaleProgress.logic';
import { DiscountScaleProgressMiniMilestone } from './discount-scale-progress-mini-milestone/DiscountScaleProgressMiniMilestone';
import { DISCOUNT_MILESTONE_OFFSETS } from './discount-scale-progress-mini-milestone/DiscountScaleProgressMiniMilestone.constants';

export const DiscountScaleProgressMini = (props: DiscountScaleProgressProps) => {
  const { discountScales, containerStyle, showAnimationMilestone, isMobile } = props;
  const { animatedProgressStyle, setLayoutWidth, steps, progressSV, lastReachedMilestone, anyMilestoneShowingCheckSV } =
    useDiscountScaleProgress(props, DISCOUNT_MILESTONE_OFFSETS);

  return (
    <View style={[styles.progressWrapper, containerStyle]} onLayout={e => setLayoutWidth(e.nativeEvent.layout.width)}>
      <View style={styles.progressBackground}>
        <Animated.View style={[styles.progressFill, animatedProgressStyle]} />
      </View>
      <View style={styles.milestonesContainer}>
        {discountScales.map((discountScale, index) => (
          <DiscountScaleProgressMiniMilestone
            key={'DiscountScaleProgressMiniMilestone' + index}
            item={discountScale}
            index={index}
            steps={steps}
            progressSV={progressSV}
            anyMilestoneShowingCheckSV={anyMilestoneShowingCheckSV}
            lastReachedMilestone={lastReachedMilestone}
            showAnimationMilestone={showAnimationMilestone}
            isMobile={isMobile}
          />
        ))}
      </View>
    </View>
  );
};
